module.exports = __webpack_public_path__ + "static/media/long-20.4de8be30.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pitch-deck/long/long-20.png
// module id = 2144
// module chunks = 0